<template>
  <div class="card-wrap">
    <div class="field-list">
      <div class="field-item" v-for="item in headerList" :key="item.value" :style="{ width: item.width }">
        <div class="field-value link-style" @click="showTimeModal" v-if="item.value === 'productTime'">{{ dataSet.productTime }}H</div>
        <div class="field-value" v-else-if="item.value === 'demandStatus'">
          {{ dataSet.demandStatus === 0 ? "制作中" : "已完成" }}
        </div>
        <div class="effect-wrap" v-else-if="item.value === 'materialEffect'">
          <div style="padding-bottom: 4px">
            <span v-if="dataSet.materialEffect === 2" class="tag tag-yx">有效</span>
            <span v-else-if="dataSet.materialEffect === 3" class="tag tag-yxpro">有效+</span>
            <span v-else-if="dataSet.materialEffect === 4" class="tag tag-dl">带量</span>
            <span v-else class="tag tag-wsc"><i class="el-icon-minus"></i></span>
          </div>
        </div>
        <div class="field-value" v-else>{{ dataSet[item.value] }}</div>
      </div>
      <div style="margin-left: auto; margin-right: 32px; margin-top: 8px;">
        <span class="hide-btn" v-if="showDetail" @click="showDetail = false"
          >收起 <i style="transform: rotate(-90deg)" class="el-icon-d-arrow-right"></i
        ></span>
        <span class="hide-btn" v-else @click="showDetail = true"
          >展开 <i style="transform: rotate(90deg)" class="el-icon-d-arrow-right"></i
        ></span>
      </div>
    </div>
    <div class="detail-wrap" v-show="showDetail">
      <div class="detail-list">
        <div class="cell-item">
          <div class="cell-row">
            <span class="cell-label" style="width: 70px">语言：</span>
            <span class="cell-value">{{ dataSet.lang ? langName : "无语言" }}</span>
          </div>
          <div class="cell-row">
            <span class="cell-label" style="width: 70px">素材类型：</span>
            <span class="cell-value">{{ dataSet.materialType }}</span>
          </div>
          <div class="cell-row">
            <span class="cell-label" style="width: 70px">制作类型：</span>
            <span class="cell-value">{{ dataSet.productionType }}</span>
          </div>
        </div>

        <div class="cell-item">
          <span class="content-title">素材需求具体内容：</span>
          <div class="content-wrap">
            <div class="content-text">
              {{ dataSet.materialRemark }}
            </div>
          </div>
        </div>

        <div class="cell-item">
          <div class="table-title">
            个数与尺寸：<span class="title-value">{{ dataSet.materialCount }}</span>
          </div>
          <div class="table-wrap">
            <table border="1" cellpadding="5px" cellspacing="0px" class="ma-table">
              <tr v-for="item of JSON.parse(dataSet.size)" :key="item.id">
                <td>{{ item.num }}</td>
                <td>{{ item.width }}*{{ item.height }}</td>
              </tr>
            </table>
          </div>
        </div>

        <div class="cell-item">
          <div class="cell-row">
            <span class="cell-label" style="width: 120px">制作小组：</span>
            <span class="cell-value">{{ dataSet.materialGroup || "-" }}</span>
          </div>
          <div class="cell-row">
            <span class="cell-label" style="width: 120px">产品投放负责人：</span>
            <span class="cell-value">{{ dataSet.deliveryLeader || "-" }}</span>
          </div>
          <div class="cell-row">
            <span class="cell-label" style="width: 120px">验收人：</span>
            <span class="cell-value">{{ dataSet.checker || "-" }}</span>
          </div>
        </div>
        <div class="cell-item">
          <div class="cell-row">
            <span class="cell-label" style="width: 130px">素材完成时间：</span>
            <span class="cell-value">{{ dataSet.finishDate }}</span>
          </div>
          <div class="cell-row" style="margin-bottom: 0px">
            <span class="cell-label" style="width: 130px">素材组名称与地址：</span>
            <el-button
              style="text-decoration-line: underline"
              @click="checkData"
              type="text"
              :disabled="dataSet.materialGroupInfos.length === 0"
              >查看/编辑</el-button
            >
          </div>
          <div class="cell-row" style="text-align: right">
            <span
              v-if="dataSet.materialGroupInfos.length > 0"
              class="cell-value link-style"
              @click="copyData(dataSet.materialGroupInfos[0])"
              >{{ dataSet.materialGroupInfos[0].materialName }}</span
            >
            <span v-else>-</span>
          </div>
        </div>
      </div>
      <div class="footer-wrap">
        <el-button class="btn" size="mini" @click="copyFormData">复制到新增 </el-button>
        <el-button class="btn" size="mini" :disabled="dataSet.materialGroupInfos.length > 0" @click="editData">修改</el-button>
        <el-button class="btn" size="mini" type="primary" @click="checkData" :disabled="dataSet.materialGroupInfos.length > 0"
          >验收</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { copyText } from "@/utils/tool.js";
import { langList, headerList } from "../confData.js";

export default {
  name: "MaterialCard",
  props: {
    dataSet: Object,
  },
  data() {
    return {
      showDetail: false,
      langList: langList,
      headerList,
    };
  },
  computed: {
    langName() {
      const langList = this.dataSet.lang.split(",");
      let nameList = [];
      langList.forEach((item) => {
        const name = this.langList.find((child) => child.value === item).label;
        nameList.push(name);
      });
      return nameList.join("、");
    },
  },
  methods: {
    // 复用
    copyFormData() {
      this.$emit("copyFormData", this.dataSet);
    },
    //修改
    editData() {
      this.$emit("editData", this.dataSet);
    },
    //验收
    checkData() {
      this.$emit("checkData", this.dataSet);
    },
    copyData(data) {
      let text = data.materialAddr;
      if (text && copyText(text)) {
        this.$message({
          message: "素材地址复制成功",
          type: "success",
        });
      }
    },
    showTimeModal() {
      this.$emit("changeTime", this.dataSet);
    },
  },
};
</script>

<style lang="less" scoped>
.card-wrap {
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  margin-bottom: 16px;
  .link-style {
    text-decoration-line: underline;
    color: rgba(24, 144, 255, 1) !important;
    cursor: pointer;
  }
  .field-list {
    display: flex;
    flex-wrap: wrap;
    padding: 16px 0px 4px 0px;
    .field-item {
      flex-shrink: 0;
      margin-bottom: 12px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      border-left: 1px solid rgb(216, 215, 215);
      padding-left: 12px;
      .field-value {
        color: rgba(0, 0, 0, 0.85);
        font-size: 14px;
      }
      .effect-wrap {
        display: flex;
        justify-content: left;
        width: 100%;
        flex-wrap: wrap;
      }
      .tag {
        display: inline-block;
        height: 24px;
        line-height: 24px;
        font-size: 14px;
        padding: 0 6px;
        border-radius: 5px;
        min-width: 30px;
        text-align: center;
        margin-right: 4px;
        &.tag-wsc {
          background: rgb(239, 241, 245);
        }
        &.tag-yx {
          background: rgba(255, 237, 141, 1);
          color: rgba(170, 105, 8, 1);
        }
        &.tag-yxpro {
          background: rgba(143, 235, 207, 1);
          color: rgba(12, 131, 95, 1);
        }
        &.tag-dl {
          background-color: rgba(172, 131, 246, 1);
          color: white;
        }
      }
    }
    .field-item:first-child {
      border-left: none;
    }
    .hide-btn {
      color: rgba(24, 144, 255, 1);
      font-size: 12px;
      cursor: pointer;
      user-select: none;
    }
  }
  .detail-wrap {
    border-top: 1px dashed rgba(0, 0, 0, 0.2);
    .detail-list {
      margin: 16px 24px 0 24px;
      display: flex;
      justify-content: space-between;
      padding: 12px;
      border-radius: 4px;
      background: rgba(244, 244, 244, 1);
      .cell-item {
        .cell-row {
          &:not(:last-child) {
            margin-bottom: 22px;
          }
          .cell-label {
            color: rgba(0, 0, 0, 0.65);
            font-size: 14px;
            display: inline-block;
            text-align: right;
          }
          .cell-value {
            color: rgba(0, 0, 0, 0.85);
            font-size: 14px;
          }
        }
        .content-title {
          display: inline-block;
          margin-bottom: 6px;
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
        }
        .content-wrap {
          width: 400px;
          height: 84px;
          padding: 4px;
          background-color: rgba(255, 255, 255, 1);
          border-radius: 2px;
          border: 1px solid rgba(0, 0, 0, 0.15);
          box-sizing: border-box;
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
          .content-text {
            height: 100%;
            overflow: auto;
            padding: 0 8px;
            &::-webkit-scrollbar {
              width: 4px;
            }
            &::-webkit-scrollbar-thumb {
              border-radius: 10px;
              -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
              background: rgba(0, 0, 0, 0.2);
            }
          }
        }
        .table-title {
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
          margin-bottom: 6px;
          .title-value {
            color: rgba(0, 0, 0, 0.85);
            font-size: 14px;
          }
        }
        .table-wrap {
          height: 85px;
          width: 165px;
          overflow: auto;
          padding-right: 4px;
          .ma-table {
            border-collapse: collapse;
            width: 100%;
            color: rgba(0, 0, 0, 0.85);
            font-size: 14px;
            background: white;
            td {
              border: 1px solid rgba(217, 217, 217, 1);
            }
          }
        }
        .table-wrap::-webkit-scrollbar {
          width: 4px;
        }
        .table-wrap::-webkit-scrollbar-thumb {
          border-radius: 10px;
          -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
          background: rgba(0, 0, 0, 0.2);
        }
      }
    }
    .footer-wrap {
      padding: 16px 24px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .btn {
        height: 26px;
      }
    }
  }
}
</style>
